/**
 * Fuente única de navegación del ERP, agrupada por módulo de negocio
 * (ver docs/analisis/consola-admin-rediseno.md §4). Cada item declara
 * `module` — la misma clave que exige `RequireModuleAccess` y que el
 * backend exige en `requirePermission("admin:<modulo>")` — así el sidebar
 * se filtra solo, sin ifs hardcodeados por rol.
 */
export interface ConsoleNavItem {
  to: string;
  label: string;
  end?: boolean;
  icon: string;
  module: string;
}

export interface ConsoleNavGroup {
  label: string;
  items: ConsoleNavItem[];
}

export const CONSOLE_SIDEBAR_GROUPS: ConsoleNavGroup[] = [
  {
    label: "Analytics",
    items: [{ to: "/", label: "Resumen", end: true, icon: "LayoutDashboard", module: "analytics" }],
  },
  {
    label: "Operaciones",
    items: [
      { to: "/salud", label: "Salud y activación", icon: "Activity", module: "operaciones" },
      { to: "/clientes", label: "Clientes", icon: "Building2", module: "operaciones" },
    ],
  },
  {
    label: "Finanzas",
    items: [
      { to: "/planes", label: "Planes", icon: "Layers3", module: "finanzas" },
      { to: "/solicitudes", label: "Solicitudes", icon: "Inbox", module: "finanzas" },
      { to: "/suscripciones", label: "Suscripciones", icon: "CreditCard", module: "finanzas" },
    ],
  },
  {
    label: "Soporte",
    items: [{ to: "/soporte", label: "Tickets", icon: "Headphones", module: "soporte" }],
  },
  {
    label: "Plataforma",
    items: [
      { to: "/correo", label: "Correo", icon: "Mail", module: "plataforma" },
      { to: "/auditoria", label: "Auditoría", icon: "ScrollText", module: "plataforma" },
      { to: "/equipo", label: "Equipo interno", icon: "Users", module: "plataforma" },
    ],
  },
  {
    label: "Dev Tools",
    items: [{ to: "/dev-tools", label: "Herramientas de datos", icon: "Wrench", module: "dev-tools" }],
  },
];

export function getConsolePageTitle(pathname: string): string {
  for (const group of CONSOLE_SIDEBAR_GROUPS) {
    for (const item of group.items) {
      const matches = item.end ? pathname === item.to : pathname.startsWith(item.to);
      if (matches) return item.label;
    }
  }
  if (pathname.startsWith("/clientes/")) return "Cliente";
  return "RediPOS ERP";
}
